export enum AccountStatus {
  OPEN_BALANCE = 'OpenBalance',
  PENDING_PAYMENT = 'PendingPayment',
  UP_TO_DATE = 'UpToDate',
}
